import { render, staticRenderFns } from "./CharacterGroupingDetail.vue?vue&type=template&id=4546883c&scoped=true&"
import script from "./CharacterGroupingDetail.vue?vue&type=script&lang=js&"
export * from "./CharacterGroupingDetail.vue?vue&type=script&lang=js&"
import style0 from "./CharacterGroupingDetail.vue?vue&type=style&index=0&id=4546883c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4546883c",
  null
  
)

export default component.exports